/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import { withRouter } from 'react-router';
import { useHistory } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button } from 'react-bootstrap';
import _ from 'lodash';

// custom imports
import { UnitConversionDetailTableHead } from './gridComponents/tableHead';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import CommentAndCorrespondenceComponent from '../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import ViewHistoryComponent from '../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import CommentVisibleIcon from '../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../assets/images/comment-dots.svg';
import SelectBoxComponent from '../../../SharedModules/SelectBox/SelectBox';
import { viewPortHeight_355 } from '../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../SharedModules/Table/TableGridWithFeatures';
import SaveCancelPopup from '../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import * as constantMessageData from '../../../SharedModules/Errors/constantMessageData';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import {
  redirectURLLink,
  closeTab,
  checkQuarterValidation,
  compareQtrs,
  addZeroes,
} from '../../../SharedModules/CommonUtilities/commonUtilities';
import {
  autoFormateDate,
  checkActionAccessByRole,
  fromQtrToDT,
  removeErr,
  tabHighLigther,
  toQtrToDT,
  validateQuarter,
} from '../../../SharedModules/utilities/utilities';
import {
  updateUnitConversionNdc,
  GetAllRebateDropdown,
  deleteConvList,
  GetAllClaimDropdown,
  getNdcGrid,
  dispatchNdcGrid,
  dispatchBottonState,
  dispatchStatusBit,
  dispatchGetSingleNDCByMfgId,
  handleErrorMessages,
  getExistingCorrLinkIds,
  dispatchSuccessMessage,
  dispatchFirstTimeAdd,
  setCMSUnitType,
} from './store/actions';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  getNDCDetails,
  naviagteToNDCDetailsPageAction,
} from '../../Display/NDC/store/action';
import {
  BAL_PERCENT_REGEX,
  RX_WITHOUT,
} from '../../../SharedModules/AppConstants';

const UnitConversionDetail = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const gridRef = React.useRef();

  const getButtonState = useSelector(
    (state) => state.sharedState.UnitConversionReducer?.getButtonState
  );
  const successResponseFromRedux = useSelector(
    (state) => state.sharedState.UnitConversionReducer?.successResponse
  );
  const ndcDeleteTemp = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.deleteConvList
  );
  const getAllHeaderDataFromRedux = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.getNdcByMfgId
  );
  const getSingleHeaderDataFromRedux = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.getSingleNdcByMfgId
  );
  const showUCList = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.getNdcGridTableData
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.errorMessagesInRedux
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData.sort(
      (a, b) => b.corrCommentId - a.corrCommentId
    );
  });
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const firstTimeAdd = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.firstTimeAdd
  );
  const CMSUnitTypeDetail = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.CMSUnitTypeDetail
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  // local state declaration
  const [gridParams, setGridParams] = React.useState(null);
  const [handleTab, setHandleTab] = React.useState(false);

  const [loading, setLoading] = React.useState(true);
  const [successMessages, setSucessMessage] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [corrLinkID, setCorrLinkId] = React.useState(null);
  const [linkTableName, setLinkTableName] = React.useState('UNIT_CONVERSION');
  const [tableName, setTableName] = React.useState('UNIT_CONVERSION');
  const [showComments, setShowComments] = React.useState(false);
  const [cancelView, setCancelView] = React.useState(false);
  const [saveView, setSaveView] = React.useState(false);
  const [leaveEdited, setLeaveEdited] = React.useState(false);
  const [leavePage, setLeavePage] = React.useState('');
  const [pageActive, setPageActive] = React.useState();
  const [paginateView, setPaginateView] = React.useState(false);
  const [otherArr, setOtherArr] = React.useState([]);
  const [deleteSend, setDeleteSend] = React.useState([]);
  const [ndcUcDetail, setNdcUcDetail] = React.useState([]);
  const [gridApi, setGridApi] = React.useState(null);
  const [textboxPaginate, setTextboxPaginate] = React.useState();
  const [ndcDeleteTempTable, setNdcDeleteTempTable] = React.useState(
    ndcDeleteTemp && ndcDeleteTemp.length > 0 ? ndcDeleteTemp : []
  );
  const [commentFlag, setCommentFlag] = React.useState(true);
  const commentFetchSeqRef = React.useRef(0);
  const currentDrugSeqNumRef = React.useRef(null);
  const [keyValue, setKeyValue] = React.useState([]);
  const [showViewHistory, setShowViewHistory] = React.useState(false);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [getClaimList, setClaimList] = React.useState([]);

  const onGridReady = (params) => {
    setGridParams(params);
    setGridApi(params.api);
  };

  const handleFullScreenView = () => {
    dispatch(
      handleErrorMessages({
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
        detailScreenErrors: [],
      })
    );
    setSucessMessage([]);
    // dispatch(
    //       handleErrorMessages({
    //         searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
    //           ? errorMessagesFromRedux?.searchScreenErrors
    //           : [],
    //         detailScreenErrors: [],
    //       })
    //     )
    setFullScreenView(!fullScreenView);
  };
  const handleViewHistory = () => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.ucSeqNum;

    setShowViewHistory(false);

    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        UC_SEQ_NUM: selectedRow,
      });
    }
  };

  // regex to check its positive whole numbers or not
  function isNumeric(value) {
    return /^\d+$/.test(value);
  }

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);
  React.useEffect(() => {
    if (!CMSUnitTypeDetail?.CMSUnitType) {
      getNDCDetailListData();
    }
  }, [getSingleHeaderDataFromRedux]);

  const getNDCDetailListData = async () => {
    if (getSingleHeaderDataFromRedux?.NDC) {
      setLoading(true);
      const response = await getNDCDetails([
        {
          ndc: getSingleHeaderDataFromRedux?.NDC,
          drugName: getSingleHeaderDataFromRedux?.drugName,
        },
      ]);
      setLoading(false);
      dispatch(
        setCMSUnitType({
          ndc: getSingleHeaderDataFromRedux?.NDC,
          drugName: getSingleHeaderDataFromRedux?.drugName,
          CMSUnitType:
            response[0]?.cmsDrugVOs?.length > 0
              ? response[0]?.cmsDrugVOs[0]?.unitTypeCd
              : '',
          dramsUnitTypeCd: response[0]?.drugDetailVOs
            ? response[0]?.drugDetailVOs?.dramsUnitTypeCd
            : '',
        })
      );
    }
  };
  // handling highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.detailScreenErrors &&
      errorMessagesFromRedux?.detailScreenErrors.length > 0
    ) {
      tabHighLigther('/unitConversion-detail', true);
    } else {
      tabHighLigther('/unitConversion-detail', false);
    }
  }, [errorMessagesFromRedux]);

  React.useEffect(() => {
    if (
      getSingleHeaderDataFromRedux &&
      Object.keys(getSingleHeaderDataFromRedux).length > 0
    ) {
      setLoading(false);
      setTextboxPaginate(getSingleHeaderDataFromRedux.indexPaginate + 1);
      currentDrugSeqNumRef.current = getSingleHeaderDataFromRedux?.drugSeqNum;
    }
  }, [getSingleHeaderDataFromRedux]);

  React.useEffect(() => {
    if (
      getAllHeaderDataFromRedux &&
      getAllHeaderDataFromRedux?.data?.length > 0
    ) {
      setNdcUcDetail(getAllHeaderDataFromRedux.data);
    }
  }, [getAllHeaderDataFromRedux]);

  React.useEffect(() => {
    dispatch(dispatchStatusBit(0));
    window.scrollTo(0, 0);
  }, []);

  // handle after call service show success and error message
  React.useEffect(() => {
    if (
      successResponseFromRedux &&
      successResponseFromRedux.data === 'Success'
    ) {
      setSaveView(false);
      setLoading(false);
      setSucessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      // setTimeout(() => setSucessMessage([]), 5000);
      if (handleTab) {
        closeTab('/unitConversion-detail', history, dispatch);
      }
    } else {
      if (successResponseFromRedux?.error === 'API failed') {
        const localErr = [];
        localErr.push({
          field: 'failedMessage',
          errorType: 'errorMessage',
          message: constantMessageData.FAIL_PROCESSING_REQUEST,
        });
        dispatch(
          handleErrorMessages({
            searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
              ? errorMessagesFromRedux?.searchScreenErrors
              : [],
            detailScreenErrors: [...new Set(localErr)],
          })
        );
        // setTimeout(() => {
        // dispatch(
        // handleErrorMessages({
        // searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
        // ? errorMessagesFromRedux?.searchScreenErrors
        // : [],
        // detailScreenErrors: [],
        // })
        // );
        // }, 7000);
      }
      setSucessMessage([]);
    }
  }, [successResponseFromRedux]);
  React.useEffect(() => {
    if (!handleTab) {
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/unitConversion-detail' && !getButtonState) {
            item.isFormDirty = true;
          } else if (item.navTo === '/unitConversion-detail')
            item.isFormDirty = false;
          return item;
        });

      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [getButtonState]);

  // close tab yes button functionality
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));

    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/unitConversion-detail' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/unitConversion-detail' && item.isFormSave) {
          item.isFormSave = false;
          saveButton(true);
          setHandleTab(true);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (showUCList && showUCList.length > 0) {
      const tempObj = showUCList?.map((item) => {
        if (
          item.corrLinkId === corrLinkID &&
          commentsList &&
          commentsList.length > 0
        ) {
          item.ccCommentExist = 1;
        } else if (item.corrLinkId === corrLinkID) {
          item.ccCommentExist = 0;
        }
        return item;
      });

      dispatch(dispatchNdcGrid(tempObj));
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api?.refreshCells();
    }
  }, [commentsList]);

  // handle existing comments
  const handleExistingCommentList = async (data) => {
    if (
      data &&
      data?.length > 0 &&
      UnitConversionDetailTableHead?.filter((x) => {
        return x.headerName === 'Start Qtr';
      }).length > 0
    ) {
      setCommentFlag(false);

      const fetchSeq = (commentFetchSeqRef.current += 1);
      const requestedDrugSeqNum = data?.[0]?.drugSeqNum ?? null;

      const result = await getExistingCorrLinkIds({
        corrLinkId: data.map((item) => item.corrLinkId),
      });

      if (fetchSeq !== commentFetchSeqRef.current) return;
      if (
        requestedDrugSeqNum &&
        requestedDrugSeqNum !== currentDrugSeqNumRef.current
      ) {
        return;
      }

      const tempObj = data.map((item) => {
        const hasComment =
          result &&
          result.data?.length > 0 &&
          result.data.includes(item.corrLinkId);

        return { ...item, ccCommentExist: hasComment ? 1 : 0 };
      });

      dispatch(dispatchNdcGrid(tempObj));
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api?.refreshCells();
    }
  };

  // call to show row field errors
  const callErrorResponses = (arr) => {
    const errShow =
      errorMessagesFromRedux?.detailScreenErrors?.length > 0
        ? errorMessagesFromRedux?.detailScreenErrors
        : [];
    arr.forEach((item, index) => {
      if (item.startQTRErr) {
        errShow.push({
          field: 'startErr',
          message: item.startError,
          index: index,
        });
      }
      if (item.endQTRErr) {
        errShow.push({
          field: 'endErr',
          message: item.endError,
          index: index,
        });
      }
      if (item.billedUnitFactorErr) {
        errShow.push({
          field: 'billedErr',
          message: item.buildError,
          index: index,
        });
      }
      if (item.cmsUnitFactorErr) {
        errShow.push({
          field: 'cmsErr',
          message: item.cmsError,
          index: index,
        });
      }
    });

    dispatch(
      handleErrorMessages({
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
        detailScreenErrors: [...new Set(errShow.filter((o) => o.message))],
      })
    );
    if (errShow?.length > 0) {
      window.scrollTo(0, 0);
    }
  };

  const buildEmptyUnitConversionRow = (indexNumber = 0) => ({
    billedUnitFactor: '',
    ccCommentExist: 0,
    cfEndQTR: '',
    cfStartQTR: '',
    cmsUnitFactor: '',
    corrLinkId: null,
    dramsUnitTypeCd: CMSUnitTypeDetail?.dramsUnitTypeCd || '',
    drugSeqNum: getSingleHeaderDataFromRedux?.drugSeqNum,
    endQTR: '',
    procedureCD: '',
    startQTR: '',
    ucClaimCategoryCD: '',
    ucDeleteAllowed: 'Y',
    ucRebateProgramCD: '',
    ucSeqNum: null,
    unitTypeCd: CMSUnitTypeDetail?.CMSUnitType || '',
    indexNumber,
    startQTRErr: false,
    endQTRErr: false,
    billedUnitFactorErr: false,
    cmsUnitFactorErr: false,
    isExistOnDb: false,
    startError: '',
    endError: '',
    cmsError: '',
    buildError: '',
  });

  React.useEffect(() => {
    const isEmptyGrid =
      Array.isArray(showUCList) &&
      showUCList.length === 0 &&
      getSingleHeaderDataFromRedux?.drugSeqNum;

    const singleEmptyRow =
      Array.isArray(showUCList) &&
      showUCList.length === 1 &&
      !showUCList[0]?.corrLinkId &&
      (!showUCList[0]?.dramsUnitTypeCd ||
        showUCList[0]?.dramsUnitTypeCd === '') &&
      (!showUCList[0]?.unitTypeCd || showUCList[0]?.unitTypeCd === '');

    // When no unit conversion records exist (e.g. Invoice Quarter >
    // Go to Maintain Unit Conversion), show an empty editable row with Add
    // instead of "There is no data to display."
    if (isEmptyGrid) {
      dispatch(dispatchNdcGrid([buildEmptyUnitConversionRow()]));
      if (firstTimeAdd) {
        dispatch(dispatchFirstTimeAdd(false));
      }
      return;
    }

    if (
      singleEmptyRow &&
      (CMSUnitTypeDetail?.CMSUnitType || CMSUnitTypeDetail?.dramsUnitTypeCd)
    ) {
      const updated = [...showUCList];
      updated[0] = {
        ...updated[0],
        dramsUnitTypeCd: CMSUnitTypeDetail?.dramsUnitTypeCd || '',
        unitTypeCd: CMSUnitTypeDetail?.CMSUnitType || '',
        drugSeqNum:
          getSingleHeaderDataFromRedux?.drugSeqNum || updated[0]?.drugSeqNum,
        isExistOnDb: false,
      };
      dispatch(dispatchNdcGrid(updated));
    }
  }, [showUCList, CMSUnitTypeDetail, getSingleHeaderDataFromRedux?.drugSeqNum]);
  // Table grid rowdata when updated
  React.useEffect(() => {
    if (showUCList?.length > 0) {
      callErrorResponses(showUCList);
      if (commentFlag) {
        handleExistingCommentList(showUCList);
      }
    }
  }, [showUCList && CMSUnitTypeDetail]);
  React.useEffect(() => {
    if (!rebateProgramList?.length > 0) {
      GetAllRebateDropdown().then((res) => {
        let list = [];
        if (
          res?.status === constantMessageData.STATUS_MSG &&
          res?.message === constantMessageData.SUCCESS_MSG
        ) {
          if (!_.isEmpty(res.data)) {
            list = _.map(res.data, (val) => ({
              ...val,
              id: val.rebateProgramCd,
              name: `${val.rebateProgramCd} | ${val.shortDescr}`,
            }));
          }
        }

        list.push({
          id: 'ALL',
          name: 'ALL',
        });

        setRebateProgramList(
          list.sort((key, val) =>
            key.name.toLowerCase().localeCompare(val.name.toLowerCase())
          )
        );
      });
    }
  }, []);
  React.useEffect(() => {
    if (!getClaimList?.length > 0) {
      GetAllClaimDropdown({
        codeDomainList: ['UC_CLAIM_CATEGORY_CD'],
      }).then((res) => {
        if (res && res.UC_CLAIM_CATEGORY_CD) {
          const list = _.map(res?.UC_CLAIM_CATEGORY_CD, (val) => ({
            ...val,
            id: val?.codeValueID.codeValue,
            name: `${val?.codeValueID.codeValue}  |
           
            ${val?.shortDescription}`,
          }));
          const obj = {
            id: 'ALL',
            name: 'ALL',
          };
          const obj2 = {
            id: 'ALXJ',
            name: 'ALXJ',
          };
          list.push(obj);
          list.push(obj2);

          setClaimList(list);
        }
      });
    }
  }, []);
  React.useEffect(() => {
    // dispatch(
    //   handleErrorMessages({
    //     searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
    //       ? errorMessagesFromRedux?.searchScreenErrors
    //       : [],
    //     detailScreenErrors: [],
    //   })
    // )
    //setSucessMessage([])
  }, [successResponseFromRedux, errorMessagesFromRedux]);
  const resetTableField = () => {
    dispatch(
      handleErrorMessages({
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
        detailScreenErrors: [],
      })
    );
    setSucessMessage([]);
    dispatch(dispatchBottonState(true));

    if (showUCList && showUCList.length > 0) {
      const clearedRows = showUCList.map((row) => ({
        ...row,
        startQTRErr: false,
        endQTRErr: false,
        billedUnitFactorErr: false,
        cmsUnitFactorErr: false,
        startError: '',
        endError: '',
        cmsError: '',
        buildError: '',
      }));
      dispatch(dispatchNdcGrid(clearedRows));
    }

    dispatch(
      getNdcGrid({
        drugSeqNum: getSingleHeaderDataFromRedux?.drugSeqNum,
      })
    );
    dispatch(
      handleErrorMessages({
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
        detailScreenErrors: [],
      })
    );
    dispatch(setCMSUnitType({}));
    setCancelView(false);
  };

  const changeRebateFilter = (cellInfo, getval, UCList, errorMsgs) => {
    dispatch(dispatchSuccessMessage({}));
    let getErrors = errorMsgs || [];
    getErrors = getErrors?.filter((item) => item.field !== 'overlap');

    const newVal = getval;
    const curtCol = cellInfo.column.colId;
    cellInfo.node.setDataValue(curtCol, newVal);

    UCList[cellInfo.node.data.indexNumber] = cellInfo.node.data;
    dispatch(dispatchNdcGrid(UCList));
    dispatch(
      handleErrorMessages({
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
        detailScreenErrors: getErrors,
      })
    );
  };

  const changeClaimFilter = (cellInfo, getval, UCList, errorMsgs) => {
    dispatch(dispatchSuccessMessage({}));
    let getErrors = errorMsgs || [];
    getErrors = getErrors?.filter((item) => item.field !== 'overlap');
    const newVal = getval;
    const curtCol = cellInfo.column.colId;
    cellInfo.node.setDataValue(curtCol, newVal);

    if (newVal === 'MD' || newVal === 'MN') {
      const newData = {
        ...cellInfo.node.data,
        disableBit: false,
      };
      cellInfo.node.setData(newData);
      UCList[cellInfo.node.data.indexNumber] = newData;
      dispatch(dispatchNdcGrid(UCList));
    } else {
      const newData = {
        ...cellInfo.node.data,
        disableBit: true,
      };
      cellInfo.node.setData(newData);
      UCList[cellInfo.node.data.indexNumber] = newData;
      dispatch(dispatchNdcGrid(UCList));
    }
    dispatch(
      handleErrorMessages({
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
        detailScreenErrors: getErrors,
      })
    );
  };

  const validateData = (data) => {
    const errors = [];
    const detailErrors = errorMessagesFromRedux?.detailScreenErrors;
    // for (let i = 0; i < data.length; i++) {
    const newRecord = data?.map((obj, i) => {
      const curr = { ...obj };
      if (!curr.startQTR) {
        errors.push({
          message: `${constantMessageData.START_QTR_UC + (i + 1)}.`,
        });
        curr.startQTRErr = true;
      } else if (curr.startQTR && validateQuarter(curr.startQTR).length) {
        errors.push({
          message: `${
            constantMessageData.QUARTER_FORMAT_ERROR_UC + 'at row ' + (i + 1)
          }.`,
        });
        curr.startQTRErr = true;
      } else {
        curr.startQTRErr = false;
      }
      if (curr.endQTR && validateQuarter(curr.endQTR).length) {
        errors.push({
          message: `${
            constantMessageData.QUARTER_FORMAT_ERROR_UC + 'at row ' + (i + 1)
          }.`,
        });
        curr.endQTRErr = true;
      } else {
        curr.endQTRErr = false;
      }
      if (!curr.billedUnitFactor) {
        errors.push({
          message: `${constantMessageData.BUILD_UNIT_FCTR_NULL_UC + (i + 1)}.`,
        });
        curr.billedUnitFactorErr = true;
      } else curr.billedUnitFactorErr = false;
      if (curr.ucClaimCategoryCD === '-1' || !curr.ucClaimCategoryCD) {
        errors.push({
          message: `${constantMessageData.CLAIM_CATEGORY_NULL_UC + (i + 1)}.`,
        });
        curr.ucClaimCategoryError = true;
      } else curr.ucClaimCategoryError = false;
      if (!curr.ucRebateProgramCD || curr.ucRebateProgramCD === '-1') {
        errors.push({
          message: `${constantMessageData.REBATE_PROGRAM_NULL_UC + (i + 1)}.`,
        });
        curr.rebatePgmErr = true;
      } else curr.rebatePgmErr = false;
      if (!curr.cmsUnitFactor) {
        errors.push({
          message: `${constantMessageData.CMS_UNIT_FCTR_NULL_UC + (i + 1)}.`,
        });
        curr.cmsUnitFactorErr = true;
      } else curr.cmsUnitFactorErr = false;
      return curr;
    });
    const tbdata = [...newRecord];
    for (let i = 0; i < tbdata.length; i++) {
      for (let j = i + 1; tbdata.length > j; j++) {
        if (
          !tbdata[i]?.billedUnitFactorErr &&
          !tbdata[j]?.billedUnitFactorErr &&
          !tbdata[i]?.ucClaimCategoryError &&
          !tbdata[j]?.ucClaimCategoryError &&
          tbdata[i].ucClaimCategoryCD === tbdata[j].ucClaimCategoryCD &&
          tbdata[i].billedUnitFactor === tbdata[j].billedUnitFactor &&
          tbdata[i].addEditRow
        ) {
          let iFromDt;
          let iToDt;
          let jFromDt;
          let jToDt;
          if (tbdata[i].startQTR && !tbdata[i].startQTRErr)
            iFromDt = new Date(fromQtrToDT(tbdata[i].startQTR));
          if (tbdata[i].endQTR && !tbdata[i].endQTRErr)
            iToDt = new Date(toQtrToDT(tbdata[i].endQTR));
          if (tbdata[j].startQTR && !tbdata[j].startQTRErr)
            jFromDt = new Date(fromQtrToDT(tbdata[j].startQTR));
          if (tbdata[j].endQTR && !tbdata[j].endQTRErr)
            jToDt = new Date(toQtrToDT(tbdata[j].endQTR));
          if (iFromDt && iToDt && jFromDt && jToDt) {
            if (iFromDt <= jToDt && jFromDt <= iToDt) {
              tbdata[i].startQTRErr = true;
              tbdata[i].endQTRErr = true;
              tbdata[j].startQTRErr = true;
              tbdata[j].endQTRErr = true;
              errors.push({
                field: 'overlap',
                message: `Start and End Quarter overlap in row #${i + 1} and ${
                  j + 1
                }`,
              });
            }
          } else if (iFromDt && iToDt && jFromDt && !jToDt) {
            if (jFromDt > iFromDt && jFromDt < iToDt) {
              tbdata[i].startQTRErr = true;
              tbdata[i].endQTRErr = true;
              tbdata[j].startQTRErr = true;
              errors.push({
                field: 'overlap',
                message: `Start and End Quarter overlap in row #${i + 1} and ${
                  j + 1
                }`,
              });
            }
          } else if (iFromDt && !iToDt && jFromDt && jToDt) {
            if (iFromDt > jFromDt && iFromDt < jToDt) {
              tbdata[i].startQTRErr = true;
              tbdata[j].startQTRErr = true;
              tbdata[j].endQTRErr = true;
              errors.push({
                field: 'overlap',
                message: `Start and End Quarter overlap in row #${i + 1} and ${
                  j + 1
                }`,
              });
            }
          }
        }
      }
    }
    return { errors: errors?.filter((o) => o.message), tbdata };
  };

  const addNewRow = (e, cellInfo, arrList, drug, unitTypeDetail) => {
    setSucessMessage([]);
    dispatch(dispatchBottonState(false));
    dispatch(dispatchSuccessMessage({}));

    const localArr = arrList || [];
    const { errors, tbdata } = validateData(localArr);
    if (errors?.length) {
      dispatch(dispatchNdcGrid(tbdata));
      dispatch(
        handleErrorMessages({
          searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
            ? errorMessagesFromRedux?.searchScreenErrors
            : [],
          detailScreenErrors: errors,
        })
      );
      window.scrollTo(0, 0);
    } else {
      const obj = {
        billedUnitFactor: '',
        ccCommentExist: 0,
        cfEndQTR: '',
        cfStartQTR: '',
        cmsUnitFactor: '',
        corrLinkId: null,
        dramsUnitTypeCd: unitTypeDetail?.dramsUnitTypeCd || '',
        drugSeqNum: drug?.drugSeqNum,
        endQTR: '',
        procedureCD: '',
        startQTR: '',
        ucClaimCategoryCD: '',
        ucDeleteAllowed: 'Y',
        ucRebateProgramCD: '',
        ucSeqNum: null,
        unitTypeCd: unitTypeDetail?.CMSUnitType || '',
        indexNumber: arrList[arrList.length - 1].indexNumber + 1,
        startQTRErr: false,
        endQTRErr: false,
        billedUnitFactorErr: false,
        cmsUnitFactorErr: false,
        isExistOnDb: false,
        ucClaimCategoryCDAutoFocus: false,
        ucRebateProgramCDAutoFocus: false,
        startError: '',
        endError: '',
        cmsError: '',
        buildError: '',
      };

      dispatch(dispatchNdcGrid([...localArr, obj]));
    }
    cellInfo.api.refreshCells();
  };

  const deleteUcFromTable = (bit, cellInfo, UcList) => {
    dispatch(dispatchSuccessMessage({}));
    const obj = {};
    obj.value = cellInfo.data.ucSeqNum;
    obj.indexNumber = cellInfo.data.indexNumber;
    dispatch(deleteConvList(obj));

    let tempList = [];
    tempList = UcList.filter((el) => {
      return el.indexNumber !== cellInfo.data.indexNumber;
    });

    dispatch(dispatchNdcGrid(tempList));
  };

  // handling pagination from header
  const paginateData = (indexNumber, flag) => {
    dispatch(dispatchSuccessMessage({}));
    dispatch(setCMSUnitType({}));

    setCommentFlag(true);
    if (!flag) {
      dispatch(dispatchGetSingleNDCByMfgId(ndcUcDetail[indexNumber]));
      dispatch(
        getNdcGrid({
          drugSeqNum: ndcUcDetail[indexNumber]?.drugSeqNum,
        })
      );
      setTextboxPaginate(ndcUcDetail[indexNumber].indexPaginate + 1);
    } else {
      setTextboxPaginate(indexNumber);
    }
  };

  // handing Pagination validation on Blur event
  const handlePaginateBlur = () => {
    dispatch(dispatchSuccessMessage({}));
    const arr = [];
    // eslint-disable-next-line no-unused-vars
    let isInputValue = false;

    const inputValue = isNumeric(textboxPaginate);

    if ((inputValue && textboxPaginate) > ndcUcDetail.length) {
      arr.push({
        field: 'input',
        errorType: 'inputIsGreter',
        message: constantMessageData.INPUT_VALUE_GRETER_THAN_TOTAL_COUNT,
      });
    } else {
      isInputValue = true;
      const indexOf = !_.isEmpty(arr)
        ? _.findIndex(arr, { field: 'input', errorType: 'inputIsGreter' })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        arr.splice(indexOf, 1);
      }
    }

    if (inputValue && isInputValue && textboxPaginate !== '0') {
      const indexOf = !_.isEmpty(arr)
        ? _.findIndex(arr, { field: 'input', errorType: 'validate' })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        arr.splice(indexOf, 1);
      }

      dispatch(
        dispatchGetSingleNDCByMfgId(
          ndcUcDetail[parseInt(textboxPaginate, [1, 1000]) - 1]
        )
      );
      dispatch(
        getNdcGrid({
          drugSeqNum:
            ndcUcDetail[parseInt(textboxPaginate, [1, 1000]) - 1]?.drugSeqNum,
        })
      );
      dispatch(setCMSUnitType({}));

      setTextboxPaginate(textboxPaginate);
    } else {
      if (inputValue && textboxPaginate < ndcUcDetail.length) {
        arr.push({
          field: 'input',
          errorType: 'validate',
          message: constantMessageData.ERR_PAGINATE_VALUE,
        });
      }
      if (inputValue === false) {
        arr.push({
          field: 'input',
          errorType: 'validate',
          message: constantMessageData.ERR_PAGINATE_VALUE,
        });
      }
    }
    dispatch(
      handleErrorMessages({
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
        detailScreenErrors: [...new Set(arr)],
      })
    );
    window.scrollTo(0, 0);
  };

  const checkFieldVal = (cellIn, value, ndcGridUc, errorMsgs) => {
    const UCList = ndcGridUc || [];
    let getErrors = errorMsgs || [];

    dispatch(dispatchSuccessMessage({}));
    let newData = {};
    if (cellIn?.colDef?.headerName === 'Start Qtr') {
      getErrors = getErrors?.filter(
        (item) =>
          item.field !== 'startErr' &&
          item.index !== cellIn.node.data.indexNumber
      );

      if (!value) {
        getErrors = getErrors?.filter((item) => item);
        newData = {
          ...cellIn.node.data,
          startQTRErr: true,
          startError: `${
            constantMessageData.START_QTR_UC + (cellIn.rowIndex + 1)
          }.`,
        };

        cellIn.node.setData(newData);
        UCList[cellIn.node.data.indexNumber] = newData;
      } else if (!checkQuarterValidation(value)) {
        newData = {
          ...cellIn.node.data,
          startQTRErr: true,
          startError: `${constantMessageData.QUARTER_FORMAT_ERROR_UC} at Row ${
            cellIn.rowIndex + 1
          }.`,
        };

        cellIn.node.setData(newData);
        UCList[cellIn.node.data.indexNumber] = newData;
      } else if (cellIn.data.endQTR && compareQtrs(value, cellIn.data.endQTR)) {
        newData = {
          ...cellIn.node.data,
          startQTRErr: true,
          startError: constantMessageData.STRT_QTR_ERROR_UC,
        };
        cellIn.node.setData(newData);

        UCList[cellIn.node.data.indexNumber] = newData;
      } else {
        // Positive case
        newData = {
          ...cellIn.node.data,
          startQTRErr: false,
          startError: '',
        };
        cellIn.node.setData(newData);
        UCList[cellIn.node.data.indexNumber] = newData;
      }

      dispatch(dispatchNdcGrid(UCList));
    }

    if (cellIn?.colDef?.headerName === 'End Qtr') {
      getErrors = getErrors?.filter(
        (item) =>
          item.field !== 'endErr' && item.index !== cellIn.node.data.indexNumber
      );
      if (value && value !== '') {
        if (!checkQuarterValidation(value)) {
          newData = {
            ...cellIn.node.data,
            endQTRErr: true,
            endError: `${constantMessageData.QUARTER_FORMAT_ERROR_UC} at Row ${
              cellIn.rowIndex + 1
            }.`,
          };
          cellIn.node.setData(newData);

          UCList[cellIn.node.data.indexNumber] = newData;
        } else if (
          cellIn.data.startQTR &&
          compareQtrs(cellIn.data.startQTR, value)
        ) {
          newData = {
            ...cellIn.node.data,
            endQTRErr: true,
            endError: constantMessageData.END_QTR_ERROR_UC,
          };
          cellIn.node.setData(newData);

          UCList[cellIn.node.data.indexNumber] = newData;
        } else {
          newData = {
            ...cellIn.node.data,
            endQTRErr: false,
            endError: '',
          };
          cellIn.node.setData(newData);

          UCList[cellIn.node.data.indexNumber] = newData;
        }
      } else if (!value) {
        getErrors = getErrors?.filter((item) => item);
        newData = {
          ...cellIn.node.data,
          endQTRErr: false,
          endError: '',
        };
        cellIn.node.setData(newData);
        UCList[cellIn.node.data.indexNumber] = newData;
      }

      dispatch(dispatchNdcGrid(UCList));
    }

    if (cellIn?.colDef?.headerName === 'Billed Unit Factor') {
      getErrors = getErrors?.filter(
        (item) =>
          item.field !== 'billedErr' &&
          item.index !== cellIn.node.data.indexNumber
      );

      if (!value) {
        newData = {
          ...cellIn.node.data,
          billedUnitFactorErr: true,
          buildError: `${
            constantMessageData.BUILD_UNIT_FCTR_NULL_UC + (cellIn.rowIndex + 1)
          }.`,
        };
        cellIn.node.setData(newData);

        UCList[cellIn.node.data.indexNumber] = newData;
      } else {
        const newVal = addZeroes(value.toString());

        cellIn.node.data.billedUnitFactor = newVal;

        newData = {
          ...cellIn.node.data,
          billedUnitFactorErr: false,
          buildError: '',
        };
        cellIn.node.setData(newData);

        UCList[cellIn.node.data.indexNumber] = newData;
      }
      dispatch(dispatchNdcGrid(UCList));
    }

    if (cellIn?.colDef?.headerName === 'CMS Unit Factor') {
      getErrors = getErrors?.filter(
        (item) =>
          item.field !== 'cmsErr' && item.index !== cellIn.node.data.indexNumber
      );
      if (!value) {
        newData = {
          ...cellIn.node.data,
          cmsUnitFactorErr: true,
          cmsError: `${
            constantMessageData.CMS_UNIT_FCTR_NULL_UC + (cellIn.rowIndex + 1)
          }.`,
        };
        cellIn.node.setData(newData);

        UCList[cellIn.node.data.indexNumber] = newData;
      } else {
        const newVal = addZeroes(value.toString());

        cellIn.node.data.cmsUnitFactor = newVal;

        newData = {
          ...cellIn.node.data,
          cmsUnitFactorErr: false,
          cmsError: '',
        };
        cellIn.node.setData(newData);

        UCList[cellIn.node.data.indexNumber] = newData;
      }

      dispatch(dispatchNdcGrid(UCList));
    }

    dispatch(
      handleErrorMessages({
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
        detailScreenErrors: [...new Set(getErrors)],
      })
    );

    callErrorResponses(UCList);
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));

    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/unitConversion-detail') {
          item.isFormDirty = true;
        } else {
          item.isFormDirty = false;
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));

    // eslint-disable-next-line no-unused-expressions
    cellIn.api.refreshCells();
  };

  const checkClassHighlighted = (cellInfo) => {
    if (cellInfo.column.colId === 'startQTR') {
      if (cellInfo.data.startQTRErr) {
        return 'td-active-cell tBill-validate frr-display-hidden-label frr-removespace-label';
      }
      return 'frr-display-hidden-label frr-removespace-label';
    }
    if (cellInfo.column.colId === 'endQTR') {
      if (cellInfo.data.endQTRErr) {
        return 'td-active-cell tBill-validate frr-display-hidden-label frr-removespace-label';
      }
      return 'frr-display-hidden-label frr-removespace-label';
    }
    if (cellInfo.column.colId === 'billedUnitFactor') {
      if (cellInfo.data.billedUnitFactorErr) {
        return 'td-active-cell tBill-validate frr-display-hidden-label frr-removespace-label';
      }
      return 'frr-display-hidden-label frr-removespace-label';
    }
    if (cellInfo.column.colId === 'cmsUnitFactor') {
      if (cellInfo.data.cmsUnitFactorErr) {
        return 'td-active-cell tBill-validate frr-display-hidden-label frr-removespace-label';
      }
      return 'frr-display-hidden-label frr-removespace-label';
    }

    return 'frr-display-hidden-label frr-removespace-label';
  };

  const detailsFrameworkComponents = {
    ActionCellRender: (cellInfo) => {
      const ndcGridTable = useSelector(
        (state) =>
          state?.sharedState?.UnitConversionReducer?.getNdcGridTableData
      );
      const drug = useSelector(
        (state) =>
          state?.sharedState?.UnitConversionReducer?.getSingleNdcByMfgId
      );
      const CMSUnitType = useSelector(
        (state) => state?.sharedState?.UnitConversionReducer?.CMSUnitTypeDetail
      );
      const [deleteModal, setDeleteModal] = React.useState(false);

      return (
        <>
          <SaveCancelPopup
            open={deleteModal}
            data-test="cancelPopup"
            title="Delete"
            onConfim={() => {
              deleteUcFromTable(false, cellInfo, ndcGridTable);
              setDeleteModal(false);
            }}
            onCancel={() => setDeleteModal(false)}
            moduleName=""
          />
          <div className="tdCell icon-btn-group" data-testid="action-column">
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="add-tooltip">Add Row</Tooltip>}
            >
              <Button
                className="float-left"
                data-testid="add-new-log-check"
                aria-label="Add new log check"
                variant="text"
                onClick={(e) =>
                  addNewRow(e, cellInfo, ndcGridTable, drug, CMSUnitType)
                }
                disabled={!isEnablebyRole}
              >
                <SVGComponent iconName="Icon-addCircle" />{' '}
              </Button>
            </OverlayTrigger>
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="add-tooltip">
                  {cellInfo.data.ucDeleteAllowed === 'N'
                    ? 'Cannot Delete Unit Conversion, Unit conversion has been used, you should specify an End Quarter instead.'
                    : 'Delete Unit Conversion'}
                </Tooltip>
              }
            >
              {cellInfo.data.ucDeleteAllowed === 'Y' ? (
                <Button
                  className="float-left"
                  data-testid="add-new-log-check"
                  aria-label="Add new log check"
                  variant="text"
                  onClick={() => {
                    dispatch(
                      handleErrorMessages({
                        searchScreenErrors:
                          errorMessagesFromRedux?.searchScreenErrors
                            ? errorMessagesFromRedux?.searchScreenErrors
                            : [],
                        detailScreenErrors: [],
                      })
                    );
                    setSucessMessage([]);
                    setDeleteModal(true);
                    dispatch(dispatchBottonState(false));
                  }}
                  disabled={!isEnablebyRole}
                >
                  <SVGComponent iconName="Icon-delete" />{' '}
                </Button>
              ) : (
                <Button
                  className="float-left"
                  data-testid="add-new-log-check"
                  aria-label="Add new log check"
                  variant="text"
                  disabled
                >
                  <SVGComponent iconName="Icon-delete" />{' '}
                </Button>
              )}
            </OverlayTrigger>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
            >
              {cellInfo.data.corrLinkId ? (
                <Button
                  type="button"
                  data-testid="test-comm-dfd"
                  onClick={() => {
                    dispatch(
                      handleErrorMessages({
                        searchScreenErrors:
                          errorMessagesFromRedux?.searchScreenErrors
                            ? errorMessagesFromRedux?.searchScreenErrors
                            : [],
                        detailScreenErrors: [],
                      })
                    );
                    setSucessMessage([]);
                    setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                    setLinkTableName('UNIT_CONVERSION');
                    setTableName('');
                    setShowComments(true);
                  }}
                  tabIndex="0"
                  onKeyDown={(e) => {
                    // Handle Enter and Space key events
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault(); // Prevents the default space scrolling behavior
                      setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                      setLinkTableName('UNIT_CONVERSION');
                      setTableName('');
                      setShowComments(true);
                    }
                  }}
                  className={`th-ic comment-ic ${
                    parseInt(cellInfo.data.ccCommentExist, [0, 1]) === 1
                      ? 'frr-enabled-comment-btn '
                      : 'frr-disabled-comment-btn'
                  }`}
                  variant="text"
                >
                  {parseInt(cellInfo.data.ccCommentExist, [0, 1]) === 1 ? (
                    <img
                      aria-label="comment"
                      alt="comment"
                      src={CommentVisibleIcon}
                    />
                  ) : (
                    <img aria-label="comment" alt="comment" src={CommentIcon} />
                  )}
                </Button>
              ) : (
                <Button
                  className="frr-disabled-comment-btn"
                  variant="text"
                  aria-label="Comment"
                  disabled
                >
                  <img alt="comment" src={CommentIcon} />
                </Button>
              )}
            </OverlayTrigger>
          </div>
        </>
      );
    },
    TextBoxCellRender1: (cellInfo) => {
      const ndcGridUc = useSelector(
        (state) =>
          state?.sharedState?.UnitConversionReducer?.getNdcGridTableData
      );
      const errorMessages = useSelector(
        (state) =>
          state?.sharedState?.UnitConversionReducer?.errorMessagesFromRedux
      );

      return (
        <div
          className={clsx(
            'form-wrapper',
            'vertical-wrapper',
            'flex-no-wrap',
            'frr-unitconversionbox',
            'no-lbl'
            // errorField[cellInfo.column.colId] &&
            //   errorField?.ndc === cellInfo.node?.data.ndc
            //   ? 'ag-grid-cell-error'
            //   : null
          )}
        >
          <div>
            <TextField
              className={
                cellInfo.node.data.disableBit
                  ? 'frr-input-disabled frr-display-hidden-label frr-removespace-label'
                  : checkClassHighlighted(cellInfo)
              }
              disabled={
                //cellInfo.data.ucDeleteAllowed === 'N'||
                cellInfo.column.colId === 'procedureCD'
                  ? cellInfo.node.data.disableBit
                  : false || !isEnablebyRole
              }
              label={`label_${cellInfo.column.colId}_${cellInfo.rowIndex}`}
              id={`label_${cellInfo.column.colId}_${cellInfo.rowIndex}`}
              fullWidth
              InputLabelProps={{
                shrink: false,
              }}
              required
              data-test="checkQtrValid-id"
              placeholder=""
              inputProps={{
                minLength: 4,
                maxLength: 18,
                style: { textAlign: 'left' },
                id: `label_${cellInfo.column.colId}_${cellInfo.rowIndex}`,
              }}
              onChange={(e) => {
                dispatch(dispatchBottonState(false));
                let { value } = e.target;
                if (
                  cellInfo.column.colId === 'billedUnitFactor' ||
                  cellInfo.column.colId === 'cmsUnitFactor'
                ) {
                  if (value && value.includes('.')) {
                    if (BAL_PERCENT_REGEX.test(value)) value = e.target.value;
                    else return false;
                  } else if (RX_WITHOUT.test(value)) {
                    value = e.target.value;
                  } else {
                    return false;
                  }
                }
                cellInfo.node.setDataValue(cellInfo.column.colId, value);
              }}
              onBlur={(e) => {
                let { value } = e.target;
                if (
                  cellInfo.column.colId === 'startQTR' ||
                  cellInfo.column.colId === 'endQTR'
                ) {
                  value = autoFormateDate(value?.toUpperCase());
                  cellInfo.node.setDataValue(cellInfo.column.colId, value);
                }
                const newObj = [...ndcGridUc];
                if (cellInfo.column.colId === 'startQTR') {
                  if (
                    newObj[cellInfo?.data?.indexNumber]?.cfStartQtr != value
                  ) {
                    newObj[cellInfo?.data?.indexNumber].addEditRow = true;
                  }
                } else if (cellInfo.column.colId === 'endQTR') {
                  if (newObj[cellInfo?.data?.indexNumber]?.cfEndQtr != value) {
                    newObj[cellInfo?.data?.indexNumber].addEditRow = true;
                  }
                }
                newObj[cellInfo?.data?.indexNumber][cellInfo.column.colId] =
                  value;
                dispatchNdcGrid(newObj);
                checkFieldVal(
                  cellInfo,
                  value,
                  ndcGridUc,
                  errorMessages?.detailScreenErrors
                );
              }}
              value={cellInfo.value || ''}
              onFocus={(e) => {
                dispatch(
                  handleErrorMessages({
                    searchScreenErrors:
                      errorMessagesFromRedux?.searchScreenErrors
                        ? errorMessagesFromRedux?.searchScreenErrors
                        : [],
                    detailScreenErrors: [],
                  })
                );
                setSucessMessage([]);
                const agGridBody = e.currentTarget.closest('.ag-body-viewport');
                agGridBody
                  .querySelectorAll('.ag-row-selected')
                  .forEach((b) => b.classList.remove('ag-row-selected'));
                e.currentTarget
                  .closest('.ag-row')
                  .classList.add('ag-row-selected');
              }}
              error={
                cellInfo.column.colId === 'billedUnitFactor'
                  ? cellInfo.data.billedUnitFactorErr
                  : cellInfo.column.colId === 'cmsUnitFactor'
                  ? cellInfo.data.cmsUnitFactorErr
                  : cellInfo.column.colId === 'startQTR'
                  ? cellInfo.data.startQTRErr
                  : cellInfo.column.colId === 'endQTR'
                  ? cellInfo.data.endQTRErr
                  : false
              }
              onKeyDown={(e) => {
                if (e.keyCode === 9) {
                  const newObj = [...ndcGridUc];
                  if (cellInfo.column.colId === 'cmsUnitFactor') {
                    newObj[
                      cellInfo?.data?.indexNumber
                    ].ucClaimCategoryCDAutoFocus = true;
                    newObj[
                      cellInfo?.data?.indexNumber
                    ].ucRebateProgramCDAutoFocus = false;

                    dispatchNdcGrid(newObj);
                  }
                  if (cellInfo.column.colId === 'procedureCD') {
                    newObj[
                      cellInfo?.data?.indexNumber
                    ].ucClaimCategoryCDAutoFocus = false;
                    newObj[
                      cellInfo?.data?.indexNumber
                    ].ucRebateProgramCDAutoFocus = true;

                    dispatchNdcGrid(newObj);
                  }
                }
              }}
            />
          </div>
        </div>
      );
    },
    ProcedureCDTextBoxCellRender: (cellInfo) => {
      const ndcGridUc = useSelector(
        (state) =>
          state?.sharedState?.UnitConversionReducer?.getNdcGridTableData
      );
      const errorMessages = useSelector(
        (state) =>
          state?.sharedState?.UnitConversionReducer?.errorMessagesFromRedux
      );

      return (
        <div
          className={clsx(
            'form-wrapper',
            'vertical-wrapper',
            'flex-no-wrap',
            'frr-unitconversionbox',
            'no-lbl'
          )}
        >
          <div>
            <TextField
              className={
                cellInfo.node.data.disableBit
                  ? 'frr-input-disabled frr-display-hidden-label frr-removespace-label'
                  : checkClassHighlighted(cellInfo)
              }
              disabled={
                (cellInfo.column.colId === 'procedureCD'
                  ? cellInfo.node.data.disableBit
                  : false) || !isEnablebyRole
              }
              label={`label_${cellInfo.column.colId}_${cellInfo.rowIndex}`}
              id={`label_${cellInfo.column.colId}_${cellInfo.rowIndex}`}
              fullWidth
              InputLabelProps={{
                shrink: false,
              }}
              required
              data-test="checkQtrValid-id"
              placeholder=""
              inputProps={{
                minLength: 4,
                maxLength: 18,
                style: { textAlign: 'left' },
                id: `label_${cellInfo.column.colId}_${cellInfo.rowIndex}`,
              }}
              onChange={(e) => {
                dispatch(dispatchBottonState(false));
                const { value } = e.target;

                cellInfo.node.setDataValue(cellInfo.column.colId, value);
              }}
              onBlur={(e) => {
                const { value } = e.target;
                const newObj = [...ndcGridUc];
                newObj[cellInfo?.data?.indexNumber][cellInfo.column.colId] =
                  value;
                dispatchNdcGrid(newObj);
                checkFieldVal(
                  cellInfo,
                  value,
                  ndcGridUc,
                  errorMessages?.detailScreenErrors
                );
                cellInfo.node.setDataValue(cellInfo.column.colId, value);
              }}
              value={cellInfo.value || ''}
              onFocus={(e) => {
                const agGridBody = e.currentTarget.closest('.ag-body-viewport');
                agGridBody
                  .querySelectorAll('.ag-row-selected')
                  .forEach((b) => b.classList.remove('ag-row-selected'));
                e.currentTarget
                  .closest('.ag-row')
                  .classList.add('ag-row-selected');
              }}
            />
          </div>
        </div>
      );
    },
    TabFuncRender: (cellInfo) => {
      const ndcGridUc = useSelector(
        (state) =>
          state?.sharedState?.UnitConversionReducer?.getNdcGridTableData
      );
      const drug = useSelector(
        (state) =>
          state?.sharedState?.UnitConversionReducer?.getSingleNdcByMfgId
      );
      const CMSUnitType = useSelector(
        (state) => state?.sharedState?.UnitConversionReducer?.CMSUnitTypeDetail
      );
      const ref = React.useRef();
      const handleKeyDowns = (e) => {
        if (
          ((e.key === 'Tab' && !e.shiftKey) || e.key === 'ArrowRight') &&
          ndcGridUc.length === cellInfo.rowIndex + 1
        ) {
          addNewRow(e, cellInfo, ndcGridUc, drug, CMSUnitType);
        }
      };
      React.useEffect(() => {
        ref.current.parentElement.addEventListener('keydown', handleKeyDowns);
        return () => {
          ref.current.parentElement.removeEventListener(
            'keydown',
            handleKeyDowns
          );
        };
      }, []);
      return (
        <div className="delete_allowed" ref={ref}>
          {cellInfo.value}
        </div>
      );
    },
    DropDownCellRender1: (cellInfo) => {
      const errorMessages = useSelector(
        (state) =>
          state?.sharedState?.UnitConversionReducer?.errorMessagesInRedux
      );
      const ndcGridUc = useSelector(
        (state) =>
          state?.sharedState?.UnitConversionReducer?.getNdcGridTableData
      );

      return (
        <>
          <div className="selectBox2">
            <SelectBoxComponent
              labelName={`label_DDSelectBox_${cellInfo.column.colId}_${cellInfo.rowIndex}`}
              // className='frr-display-hidden-label'
              autoFocus={cellInfo?.data?.ucClaimCategoryCDAutoFocus}
              required={false}
              disabled={!isEnablebyRole}
              data-test="DDSelectBox"
              optionList={getClaimList || []}
              defaultValue={cellInfo.value || '-1'}
              isEnablebyRole={isEnablebyRole}
              filterAction={(e) => {
                changeClaimFilter(
                  cellInfo,
                  e,
                  ndcGridUc,
                  errorMessages?.detailScreenErrors
                );
                dispatch(dispatchBottonState(false));
              }}
              error={cellInfo.data.ucClaimCategoryError}
            />
          </div>
        </>
      );
    },
    DropDownCellRender2: (cellInfo) => {
      const errorMessages = useSelector(
        (state) =>
          state?.sharedState?.UnitConversionReducer?.errorMessagesInRedux
      );
      const ndcGridUc = useSelector(
        (state) =>
          state?.sharedState?.UnitConversionReducer?.getNdcGridTableData
      );
      return (
        <>
          <div className="selectBox2">
            <SelectBoxComponent
              labelName={`label_Rbc_${cellInfo.column.colId}_${cellInfo.rowIndex}`}
              // className='frr-display-hidden-label'
              autoFocus={cellInfo?.data?.ucRebateProgramCDAutoFocus}
              required={false}
              disabled={!isEnablebyRole}
              data-test="selectBox"
              optionList={rebateProgramList || []}
              defaultValue={cellInfo.value || '-1'}
              isEnablebyRole={isEnablebyRole}
              filterAction={(e) => {
                changeRebateFilter(
                  cellInfo,
                  e,
                  ndcGridUc,
                  errorMessages?.detailScreenErrors
                );
                dispatch(dispatchBottonState(false));
              }}
              onChange={(e) => {
                cellInfo.node.setDataValue(
                  cellInfo.column.colId,
                  e.target.value
                );
              }}
              error={cellInfo.data.rebatePgmErr}
            />
          </div>
        </>
      );
    },
  };

  const callQuarterIntersection = (val, list) => {
    const listStartQtr = list ? getQuarterVals(list?.startQTR) : null;
    const orgListStartQtr = getQuarterVals(val.startQTR);

    if (!listStartQtr || !orgListStartQtr) {
      return false;
    }

    // If start quarters match, they intersect
    if (listStartQtr === orgListStartQtr) {
      return true;
    }

    const listEndQtr = list?.endQTR ? getQuarterVals(list?.endQTR) : null;
    const orgListEndQtr = val?.endQTR ? getQuarterVals(val?.endQTR) : null;

    if (listEndQtr && orgListEndQtr) {
      // Handle intersection logic for both start and end quarters
      return !(listEndQtr < orgListStartQtr || orgListEndQtr < listStartQtr);
    }

    return false;
  };

  const callClaimCategoryChecks = (orgList, list) => {
    if (list.ucClaimCategoryCD === 'ALL' || list.ucClaimCategoryCD === 'ALXJ') {
      if (
        orgList.ucClaimCategoryCD === 'MD' ||
        orgList.ucClaimCategoryCD === 'MN'
      ) {
        return true; // this is correct case and, not duplicating
      }
      return false;
    }
    if (
      orgList.ucClaimCategoryCD === 'ALL' ||
      orgList.ucClaimCategoryCD === 'ALXJ'
    ) {
      if (list.ucClaimCategoryCD === 'MD' || list.ucClaimCategoryCD === 'MN') {
        return true;
      }
      return false;
    }
    if (
      list.ucClaimCategoryCD === 'MD' ||
      list.ucClaimCategoryCD === 'MN' ||
      orgList.ucClaimCategoryCD === 'MD' ||
      orgList.ucClaimCategoryCD === 'MN'
    ) {
      if (
        list.procedureCD === orgList.procedureCD ||
        list.procedureCD === null ||
        list.procedureCD === '' ||
        orgList.procedureCD === null ||
        orgList.procedureCD === ''
      ) {
        return false;
      }
      return true;
    }
    return false;
  };

  const checkDuplicateForBilledUnit = (orgList, list, listIndex) => {
    return orgList
      .map((val, index) => {
        // Call the quarter intersection check
        const intersection = callQuarterIntersection(list, val);
        if (!intersection) {
          // If quarters do not intersect, stop further checks and exit the function
          return null;
        }

        // // If quarters intersect, proceed with the checks
        if (
          list.indexNumber !== val.indexNumber &&
          list.ucClaimCategoryCD?.trim() === val.ucClaimCategoryCD?.trim()
        ) {
          if (
            (list.indexNumber !== val.indexNumber &&
              list.ucClaimCategoryCD?.trim() === 'MD') ||
            list.ucClaimCategoryCD?.trim() === 'MN'
          ) {
            if (
              list.indexNumber !== val.indexNumber &&
              list.procedureCD?.trim() === val.procedureCD?.trim()
            ) {
              return checkBilledUnit(list, val, index, listIndex);
            } else if (
              list.indexNumber !== val.indexNumber &&
              (!list.procedureCD?.trim() || !val.procedureCD?.trim())
            ) {
              return {
                pairKey: [list.indexNumber, val.indexNumber].sort().join('-'),
                message: `${
                  constantMessageData.ERR_UC_OVERLAPPING_PROCEDURE_CD_MESSAGE
                } ${
                  val?.ucClaimCategoryCD === list?.ucClaimCategoryCD
                    ? val?.ucClaimCategoryCD
                    : `${list?.ucClaimCategoryCD}/${val?.ucClaimCategoryCD}`
                } where there is at least one with a procedure code and one without. Lines ${
                  listIndex + 1
                } and ${index + 1} violate this criteria.`,
                oneIndexNumber: list.indexNumber,
                secondIndexNumber: val.indexNumber,
              };
            }
          }
        }

        return checkBilledUnit(list, val, index, listIndex);
      })
      .filter(Boolean); // Remove null entries
  };

  const checkBilledUnit = (list, val, index, listIndex) => {
    const normalize = (v) => (v == null ? '' : String(v).trim());
    if (
      list.indexNumber !== val.indexNumber &&
      normalize(list.procedureCD) === normalize(val.procedureCD) &&
      list.billedUnitFactor?.trim() === val.billedUnitFactor?.trim()
    ) {
      return {
        pairKey: [list.indexNumber, val.indexNumber].sort().join('-'),
        message: `${
          constantMessageData.ERR_UC_OVERLAP_MESSAGE + (listIndex + 1)
        } and ${index + 1} violate these criteria.`,
        oneIndexNumber: list.indexNumber,
        secondIndexNumber: val.indexNumber,
      };
    } else {
      return null;
    }
  };

  const checkDuplicate = (orgList, list, listIndex) => {
    return orgList.map((val, index) => {
      if (list.indexNumber !== val.indexNumber) {
        const result = callQuarterIntersection(val, list);

        const obj = {};
        if (result === true) {
          if (_.isEqual(list.ucRebateProgramCD, val.ucRebateProgramCD)) {
            if (_.isEqual(list.billedUnitFactor, val.billedUnitFactor)) {
              obj.message = `${
                constantMessageData.ERR_UC_OVERLAP_MESSAGE + (listIndex + 1)
              } and ${index + 1} violate these criteria.`;
              obj.oneIndexNumber = list.indexNumber;
              obj.secondIndexNumber = val.indexNumber;
              return obj;
            }
          } else {
            const claimResult = callClaimCategoryChecks(val, list);

            if (claimResult === true) {
              if (_.isEqual(list.billedUnitFactor, val.billedUnitFactor)) {
                obj.message = `${
                  constantMessageData.ERR_UC_OVERLAP_MESSAGE + (listIndex + 1)
                } and ${index + 1} violate these criteria.`;
                obj.oneIndexNumber = list.indexNumber;
                obj.secondIndexNumber = val.indexNumber;
                return obj;
              }
            } else {
              obj.message = `${
                constantMessageData.ERR_UC_OVERLAP_HCPCS_MESSAGE +
                (listIndex + 1)
              } and ${index + 1} violate these criteria.`;
              obj.oneIndexNumber = list.indexNumber;
              obj.secondIndexNumber = val.indexNumber;
              return obj;
            }
          }
        }
      }
    });
  };

  const checkQTRFormat = (value) => {
    const reTest = /^[1-4]{1}[qQ]{1}\d{4}$/;
    const reTest2 = /^[1-4]{1}[qQ]{1}\d{2}$/;
    let checkFormat1 = false;

    const checkFormat = !!(
      _.includes(value.startQTR, 'q') || _.includes(value.startQTR, 'Q')
    );

    if (value.endQTR) {
      checkFormat1 = !!(
        _.includes(value.endQTR, 'q') || _.includes(value.endQTR, 'Q')
      );
    }

    if (
      checkFormat &&
      (reTest.test(value.startQTR) || reTest2.test(value.startQTR))
    ) {
      if (checkFormat1) {
        if (reTest.test(value.endQTR) || reTest2.test(value.endQTR)) {
          return true;
        }
        return 3;
      }
      if (value.endQTR) {
        return 3;
      }
      return true;
    }
    return 2;
  };

  const getQuarterVals = (val) => {
    if (!val) return null;
    const newValue = val.toLowerCase();
    const quarterParts = newValue.split('q');

    if (quarterParts.length === 2) {
      let year = quarterParts[1];
      if (year.length === 2) {
        const currentYear = moment().format('YYYY');
        year = currentYear.slice(0, 2) + year;
      }
      return `${year}${quarterParts[0]}`;
    }
    return null;
  };

  const saveButton = (flag) => {
    // setSaveView(true);
    setLoading(true);
    const tempArr = showUCList && showUCList.length > 0 ? showUCList : [];
    const tempDelete = [];
    let error = [];

    if (ndcDeleteTemp && ndcDeleteTemp.length > 0) {
      ndcDeleteTemp.forEach((ele) => {
        if (ele.value) {
          tempDelete.push({ ucSeqNum: ele.value });
        }
      });
    }

    // if (tempArr && tempArr.length > 0) {
    //   if (tempArr.length === 1) {
    //     if (
    //       tempArr[0].startQTR !== '' &&
    //       tempArr[0].startQTR !== null &&
    //       tempArr[0].billedUnitFactor !== '' &&
    //       tempArr[0].billedUnitFactor !== null &&
    //       tempArr[0].cmsUnitFactor !== '' &&
    //       tempArr[0].cmsUnitFactor !== null &&
    //       tempArr[0].ucClaimCategoryCD !== '-1' &&
    //       tempArr[0].ucClaimCategoryCD !== '' &&
    //       tempArr[0].ucRebateProgramCD !== '-1' &&
    //       tempArr[0].ucRebateProgramCD !== ''
    //     ) {
    //       let firstCheck = false;
    //       firstCheck = checkQTRFormat(tempArr[0]);

    //       if (firstCheck === true) {
    //         const result = callQuarterIntersection(tempArr[0], null);

    //         if (result !== false) {
    //           error.push({
    //             message: constantMessageData.STRT_END_EQUAL_QTR_ERROR_UC,
    //           });
    //         }
    //       } else if (firstCheck === 2) {
    //         error.push({
    //           message: `${constantMessageData.QUARTER_FORMAT_ERROR_UC} at Row ${
    //             tempArr[0].indexNumber + 1
    //           }.`,
    //         });
    //       } else if (firstCheck === 3) {
    //         error.push({
    //           message: `${constantMessageData.QUARTER_FORMAT_ERROR_UC} at Row ${
    //             tempArr[0].indexNumber + 1
    //           }.`,
    //         });
    //       }
    //     } else {
    //       if (
    //         !tempArr[0].startQTR ||
    //         tempArr[0].startQTR === '' ||
    //         tempArr[0].startQTR === null
    //       ) {
    //         error.push({
    //           message: `${
    //             constantMessageData.START_QTR_UC + (tempArr[0].indexNumber + 1)
    //           }.`,
    //         });
    //       }
    //       if (
    //         !tempArr[0].billedUnitFactor ||
    //         tempArr[0].billedUnitFactor === '' ||
    //         tempArr[0].billedUnitFactor === null
    //       ) {
    //         error.push({
    //           message: `${
    //             constantMessageData.BUILD_UNIT_FCTR_NULL_UC +
    //             (tempArr[0].indexNumber + 1)
    //           }.`,
    //         });
    //       }
    //       if (
    //         !tempArr[0].ucClaimCategoryCD ||
    //         tempArr[0].ucClaimCategoryCD === '' ||
    //         tempArr[0].ucClaimCategoryCD === null ||
    //         tempArr[0].ucClaimCategoryCD === '-1'
    //       ) {
    //         error.push({
    //           message: `${
    //             constantMessageData.CLAIM_CATEGORY_NULL_UC +
    //             (tempArr[0].indexNumber + 1)
    //           }.`,
    //         });
    //       }
    //       if (
    //         !tempArr[0].ucRebateProgramCD ||
    //         tempArr[0].ucRebateProgramCD === '' ||
    //         tempArr[0].ucRebateProgramCD === null ||
    //         tempArr[0].ucRebateProgramCD === '-1'
    //       ) {
    //         error.push({
    //           message: `${
    //             constantMessageData.REBATE_PROGRAM_NULL_UC +
    //             (tempArr[0].indexNumber + 1)
    //           }.`,
    //         });
    //       }
    //       if (
    //         !tempArr[0].cmsUnitFactor ||
    //         tempArr[0].cmsUnitFactor === '' ||
    //         tempArr[0].cmsUnitFactor === null
    //       ) {
    //         error.push({
    //           message: `${
    //             constantMessageData.CMS_UNIT_FCTR_NULL_UC +
    //             (tempArr[0].indexNumber + 1)
    //           }.`,
    //         });
    //       }
    //     }
    //   } else {
    //     tempArr = tempArr.sort((a, b) =>
    //       // eslint-disable-next-line no-nested-ternary
    //       a.indexNumber > b.indexNumber
    //         ? 1
    //         : b.indexNumber > a.indexNumber
    //         ? -1
    //         : 0
    //     );

    //     const findArr = tempArr.filter(
    //       (item) =>
    //         !item.startQTR ||
    //         item.startQTR === '' ||
    //         item.startQTR === null ||
    //         !item.billedUnitFactor ||
    //         item.billedUnitFactor === '' ||
    //         item.billedUnitFactor === null ||
    //         !item.cmsUnitFactor ||
    //         item.cmsUnitFactor === '' ||
    //         item.cmsUnitFactor === null ||
    //         item.ucClaimCategoryCD === '-1' ||
    //         item.ucClaimCategoryCD === '' ||
    //         item.ucRebateProgramCD === '-1' ||
    //         item.ucRebateProgramCD === ''
    //     );

    //     if (findArr?.length > 0) {
    //       tempArr.forEach((val, ind) => {
    //         if (!val.startQTR || val.startQTR === '' || val.startQTR === null) {
    //           if (val.startQTRErr === false) {
    //             error.push({
    //               message: `${
    //                 constantMessageData.START_QTR_UC + (val.indexNumber + 1)
    //               }.`,
    //             });
    //             tempArr[ind].startQTRErr = true;
    //             tempArr[ind].startError = `${
    //               constantMessageData.START_QTR_UC + (val.indexNumber + 1)
    //             }.`;
    //             dispatch(dispatchNdcGrid(tempArr));
    //           }
    //         }
    //         if (
    //           !val.billedUnitFactor ||
    //           val.billedUnitFactor === '' ||
    //           val.billedUnitFactor === null
    //         ) {
    //           if (val.billedUnitFactorErr === false) {
    //             error.push({
    //               message: `${
    //                 constantMessageData.BUILD_UNIT_FCTR_NULL_UC +
    //                 (val.indexNumber + 1)
    //               }.`,
    //             });
    //             tempArr[ind].buildError = true;
    //             tempArr[ind].buildError = `${
    //               constantMessageData.BUILD_UNIT_FCTR_NULL_UC +
    //               (val.indexNumber + 1)
    //             }.`;

    //             dispatch(dispatchNdcGrid(tempArr));
    //           }
    //         }
    //         if (
    //           !val.ucClaimCategoryCD ||
    //           val.ucClaimCategoryCD === '-1' ||
    //           val.ucClaimCategoryCD === '' ||
    //           val.ucClaimCategoryCD === null
    //         ) {
    //           error.push({
    //             message: `${
    //               constantMessageData.CLAIM_CATEGORY_NULL_UC +
    //               (val.indexNumber + 1)
    //             }.`,
    //           });
    //         }
    //         if (
    //           !val.ucRebateProgramCD ||
    //           val.ucRebateProgramCD === '-1' ||
    //           val.ucRebateProgramCD === '' ||
    //           val.ucRebateProgramCD === null
    //         ) {
    //           error.push({
    //             message: `${
    //               constantMessageData.REBATE_PROGRAM_NULL_UC +
    //               (val.indexNumber + 1)
    //             }.`,
    //           });
    //         }
    //         if (
    //           !val.cmsUnitFactor ||
    //           val.cmsUnitFactor === '' ||
    //           val.cmsUnitFactor === null
    //         ) {
    //           error.push({
    //             message: `${
    //               constantMessageData.CMS_UNIT_FCTR_NULL_UC +
    //               (val.indexNumber + 1)
    //             }.`,
    //           });
    //         }
    //       });
    //     } else {
    //       // Overlap Logic
    //       tempArr.forEach((val, ind) => {
    //         let firstCheck = false;
    //         firstCheck = checkQTRFormat(val);

    //         if (firstCheck === true) {
    //           let checkPass = false;
    //           checkPass = checkDuplicate(tempArr, val, ind);

    //           if (!_.isEmpty(checkPass)) {
    //             checkPass.forEach((val1) => (val1 ? error.push(val1) : ''));
    //           }
    //         } else if (firstCheck === 2) {
    //           error.push({
    //             message: `${
    //               constantMessageData.QUARTER_FORMAT_ERROR_UC
    //             } at Row ${val.indexNumber + 1}.`,
    //           });
    //         } else if (firstCheck === 3) {
    //           error.push({
    //             message: `${
    //               constantMessageData.QUARTER_FORMAT_ERROR_UC
    //             } at Row ${val.indexNumber + 1}.`,
    //           });
    //         }
    //       });
    //     }
    //   }
    // }

    if (tempArr && tempArr.length > 0) {
      const findArr = tempArr.filter(
        (item) =>
          !item.startQTR ||
          item.startQTR === '' ||
          item.startQTR === null ||
          !item.billedUnitFactor ||
          item.billedUnitFactor === '' ||
          item.billedUnitFactor === null ||
          !item.cmsUnitFactor ||
          item.cmsUnitFactor === '' ||
          item.cmsUnitFactor === null ||
          item.ucClaimCategoryCD === '-1' ||
          item.ucClaimCategoryCD === '' ||
          item.ucRebateProgramCD === '-1' ||
          item.ucRebateProgramCD === ''
      );

      const processedPairs = new Set(); // Track unique pairs

      tempArr.forEach((val, ind) => {
        // const checkPass = checkDuplicateForBilledUnit(tempArr, val, ind);
        const checkPass = checkDuplicateForBilledUnit(
          tempArr,
          val?.addEditRow ? val : [],
          ind
        );
        if (!_.isEmpty(checkPass)) {
          checkPass.forEach((val1) => {
            if (val1 && !processedPairs.has(val1.pairKey)) {
              processedPairs.add(val1.pairKey); // Add pair to the set
              error.push(val1); // Push the error message
            }
          });
        }
      });
    }

    setOtherArr(tempArr);
    setDeleteSend(tempDelete);
    const { errors, tbdata } = validateData(tempArr);
    setLoading(false);
    if (errors.length) error = errors;
    if (error?.length > 0) {
      // const arr =
      //   errorMessagesFromRedux?.detailScreenErrors?.length > 0
      //     ? errorMessagesFromRedux?.detailScreenErrors
      //     : [];
      // const filteredArr = error.reduce((acc, current) => {
      //   const x = acc.find(
      //     (item) => item.oneIndexNumber === current.secondIndexNumber
      //   );

      //   if (!x) {
      //     return acc.concat([current]);
      //   }
      //   return acc;
      // }, []);

      // filteredArr.forEach((val) =>
      //   arr.push({
      //     field: 'overlap',
      //     message: val.message,
      //   })
      // );
      dispatch(dispatchNdcGrid(tbdata));
      dispatch(
        handleErrorMessages({
          searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
            ? errorMessagesFromRedux?.searchScreenErrors
            : [],
          detailScreenErrors: [...new Set(error)],
        })
      );
      window.scrollTo(0, 0);
    } else if (flag === false) {
      dispatch(
        handleErrorMessages({
          searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
            ? errorMessagesFromRedux?.searchScreenErrors
            : [],
          detailScreenErrors: [],
        })
      );
      setSaveView(true);
    } else {
      // setHandleTab(true);
      callSaveAPI(flag, tempArr, tempDelete);
    }
  };

  const callSaveAPI = async (flag, tempArr, tempDelete) => {
    const newArr = otherArr.map((val) => {
      delete val.startQTRErr;
      delete val.endQTRErr;
      delete val.billedUnitFactorErr;
      delete val.cmsUnitFactorErr;
      delete val.isExistOnDb;
      delete val.startError;
      delete val.endError;
      delete val.cmsError;
      delete val.buildError;
      delete val.ucClaimCategoryCDAutoFocus;
      delete val.ucRebateProgramCDAutoFocus;

      return val;
    });

    const payload = {
      unitConversionSaveVO: tempArr.map((obj) => {
        obj.lastUpdateUserID = logInUser;
        return obj;
      }),
      unitConversionDeleteVO: tempDelete.map((obj) => {
        obj.lastUpdateUserID = logInUser;
        return obj;
      }),
    };

    await dispatch(updateUnitConversionNdc(payload));

    setSaveView(false);
    setCommentFlag(true);
    dispatch(deleteConvList(0));
    dispatch(
      getNdcGrid({
        drugSeqNum: getSingleHeaderDataFromRedux?.drugSeqNum,
      })
    );
    dispatch(dispatchBottonState(true));
  };
  // navigate
  const navigateHandler = (value) => {
    const ndc = getSingleHeaderDataFromRedux.NDC;
    const { drugName } = getSingleHeaderDataFromRedux;
    if (value === 'NDC') {
      dispatch(
        naviagteToNDCDetailsPageAction({
          succesFunc: () => {
            redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
          },
          ndcDetailsTableData: [{ ndc, drugName }],
        })
      );
    }
  };
  return (
    <div
      className="unitConversion"
      data-test="unitConversion-detail-list-component"
    >
      <div className="tabs-container">
        {!fullScreenView && (
          <CustomSeparator
            parent1="Maintain"
            parent2="Display Unit Conversion for NDC"
          />
        )}
        <Spinner load={spinnerLoader} />

        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              errorMessagesFromRedux?.detailScreenErrors?.length > 0
                ? _.map(
                    errorMessagesFromRedux?.detailScreenErrors,
                    (l) => l.message
                  )
                : []
            ),
          ]}
        />
        <DisplaySuccessMessages successMessages={successMessages} />

        {!fullScreenView && (
          <>
            <Box className="alone-pagination mb-2">
              <Box>
                <Button
                  title=" Previous "
                  className="btns rotate-left"
                  data-testid="uc-paginate-arrow"
                  disabled={
                    !(getSingleHeaderDataFromRedux?.indexPaginate > 0) ||
                    !isNumeric(getSingleHeaderDataFromRedux?.indexPaginate) ||
                    ndcUcDetail?.length <
                      getSingleHeaderDataFromRedux?.indexPaginate
                  }
                  onClick={() => {
                    dispatch(
                      handleErrorMessages({
                        searchScreenErrors:
                          errorMessagesFromRedux?.searchScreenErrors
                            ? errorMessagesFromRedux?.searchScreenErrors
                            : [],
                        detailScreenErrors: [],
                      })
                    );
                    setSucessMessage([]);
                    if (getSingleHeaderDataFromRedux?.indexPaginate > 0) {
                      if (!getButtonState) {
                        setLeaveEdited(true);
                        setLeavePage('prev');
                      } else {
                        paginateData(
                          (getSingleHeaderDataFromRedux?.indexPaginate ?? 0) -
                            1,
                          false
                        );
                      }
                    }
                  }}
                >
                  <SVGComponent iconName="Icon-arrow" />
                  <span className="hide-elm">Previous</span>
                </Button>
              </Box>
              <Box>
                <label className="m-0" htmlFor="paginate-count">
                  <TextField
                    id="paginate-count"
                    data-testid="uc-input-paginate"
                    variant="outlined"
                    className="searchInput input-count"
                    value={textboxPaginate}
                    onChange={(e) => paginateData(e.target.value, true)}
                    onFocus={(e) => {
                      setPageActive(e.target.value);
                    }}
                    onBlur={() => {
                      if (!getButtonState) {
                        setLeaveEdited(true);
                        setLeavePage('type');
                      } else handlePaginateBlur();
                    }}
                    onKeyDown={(e) => {
                      if (e.keyCode === 9 || e.key === 'Enter') {
                        e.preventDefault();
                        if (!getButtonState) {
                          setLeaveEdited(true);
                          setLeavePage('type');
                        } else {
                          e.target.blur();
                          handlePaginateBlur();
                        }
                      }
                    }}
                    size="small"
                  />
                </label>
              </Box>
              <Box className="btns">of {ndcUcDetail.length}</Box>
              <Box>
                <Button
                  title="Next"
                  className="btns rotate-right ml-0"
                  data-testid="uc-paginate-arrow"
                  disabled={
                    getSingleHeaderDataFromRedux?.indexPaginate >=
                      ndcUcDetail?.length - 1 ||
                    !isNumeric(getSingleHeaderDataFromRedux?.indexPaginate)
                  }
                  onClick={() => {
                    dispatch(
                      handleErrorMessages({
                        searchScreenErrors:
                          errorMessagesFromRedux?.searchScreenErrors
                            ? errorMessagesFromRedux?.searchScreenErrors
                            : [],
                        detailScreenErrors: [],
                      })
                    );
                    setSucessMessage([]);
                    if (
                      getSingleHeaderDataFromRedux?.indexPaginate !==
                      ndcUcDetail?.length
                    ) {
                      if (!getButtonState) {
                        setLeaveEdited(true);
                        setLeavePage('next');
                      } else {
                        paginateData(
                          (getSingleHeaderDataFromRedux?.indexPaginate ?? 0) +
                            1,
                          false
                        );
                      }
                    }
                  }}
                >
                  <SVGComponent iconName="Icon-arrow" />
                  <span className="hide-elm">Next</span>
                </Button>
              </Box>
            </Box>

            <Box className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper form-wrapper-col-4">
                  <div className="mui-custom-form input-md">
                    <TextField
                      autoFocus
                      id="NDC"
                      label="NDC"
                      fullWidth
                      disabled
                      placeholder=""
                      value={getSingleHeaderDataFromRedux?.NDC}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      // value={ndcSingleDetail[0]?.ndc}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    {getSingleHeaderDataFromRedux?.drugName?.length > 20 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="com-tooltip">
                            {getSingleHeaderDataFromRedux?.drugName}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="DrugName"
                          label="Drug Name"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{ shrink: true }}
                          value={`${getSingleHeaderDataFromRedux?.drugName.substring(
                            0,
                            20
                          )} ...`}
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="DrugName"
                        label="Drug Name"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{ shrink: true }}
                        value={getSingleHeaderDataFromRedux?.drugName}
                      />
                    )}
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="EarliestClaimDate"
                      label="Earliest Claim Date"
                      fullWidth
                      disabled
                      placeholder=""
                      value={getSingleHeaderDataFromRedux?.minClaimDt}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    {getSingleHeaderDataFromRedux?.labelerName?.length > 20 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="com-tooltip">
                            {getSingleHeaderDataFromRedux?.labelerName}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="LabelerName"
                          label="Labeler Name"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{ shrink: true }}
                          value={`${getSingleHeaderDataFromRedux?.labelerName.substring(
                            0,
                            20
                          )} ...`}
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="LabelerName"
                        label="Labeler Name"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{ shrink: true }}
                        value={getSingleHeaderDataFromRedux?.labelerName}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Box>

            <div className="btn-wrapper panel-footer mt-3">
              <div className="flex-block justify-content-end tBillPanel-space-x">
                <Button
                  className="btn btn-success btn-save"
                  title="Save"
                  disabled={getButtonState}
                  onClick={() => {
                    saveButton(false);
                    setHandleTab(false);
                  }}
                >
                  <SVGComponent iconName="Icon-awesome-save" />
                  Save
                </Button>

                <Button
                  className="btn btn-default btn-cancel"
                  title="Cancel"
                  disabled={getButtonState}
                  onClick={() => setCancelView(true)}
                >
                  <SVGComponent iconName="Icon-cancel" /> Cancel
                </Button>
              </div>
            </div>
            <SaveCancelPopup
              open={cancelView}
              title="Cancel"
              data-testid="reset-button-uc"
              onConfim={resetTableField}
              onCancel={(e) => setCancelView(false)}
              moduleName=""
            />
            <SaveCancelPopup
              open={leaveEdited}
              title="Confirm Popup"
              data-testid="reset-button-uc"
              onConfim={() => {
                dispatch(dispatchBottonState(true));
                if (leavePage === 'prev') {
                  paginateData(
                    (getSingleHeaderDataFromRedux?.indexPaginate ?? 0) - 1,
                    false
                  );
                } else if (leavePage === 'next') {
                  paginateData(
                    (getSingleHeaderDataFromRedux?.indexPaginate ?? 0) + 1,
                    false
                  );
                } else if (leavePage === 'type') {
                  handlePaginateBlur();
                }
                dispatch(
                  handleErrorMessages({
                    searchScreenErrors:
                      errorMessagesFromRedux?.searchScreenErrors
                        ? errorMessagesFromRedux?.searchScreenErrors
                        : [],
                    detailScreenErrors: [],
                  })
                );
                setLeaveEdited(false);
              }}
              onCancel={(e) => {
                if (leavePage === 'type') paginateData(pageActive, true);
                setLeaveEdited(false);
              }}
              moduleName=""
            />
            <SaveCancelPopup
              open={saveView}
              title="Save"
              data-testid="save-api-uc"
              onConfim={() => callSaveAPI(false, otherArr, deleteSend)}
              onCancel={() => setSaveView(false)}
              moduleName=""
            />

            <SaveCancelPopup
              open={paginateView}
              title="Cancel"
              data-testid="cancel-paginate-popup-uc"
              // onConfim={paginateMoveButton}
              // onCancel={(e) => setPaginateView(false)}
              moduleName=""
            />
          </>
        )}
        {showComments ? (
          <CommentAndCorrespondenceComponent
            setShowComments={setShowComments}
            linkTableName={linkTableName}
            corrLinkId={corrLinkID}
          />
        ) : null}
        <div className="row">
          <div className="col-sm-12 FRR-custom-table tbl-manufacturer-inner frr-log_chk frr-display-dropdown-cell">
            {rebateProgramList?.length > 0 && getClaimList?.length > 0 && (
              <TableGridWithFeatures
                ref={gridRef}
                data-testid="manufacturer-cbi-table"
                rowSelection="single"
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                gridHeight={viewPortHeight_355}
                rowData={showUCList}
                columnDefs={UnitConversionDetailTableHead}
                // cellClickedListener={(e) => {
                //   onClickForDetail(e.data);
                // }}
                exportFile
                gridCall={onGridReady}
                // tabToNextCell={tabToNextCell}
                onCellFocused={onCellFocused}
                navigateToNextCell={navigateToNextCell}
                fileName="unit-conversion-detail"
                animateRows
                isScrollOn
                singleClickEdit
                enterMovesDown
                suppressCellFocus
                frameworkComponents={detailsFrameworkComponents}
                handleViewHistory={handleViewHistory}
                showGoToNDCOptions
                navigateHandler={navigateHandler}
              />
            )}
          </div>
        </div>
        {showViewHistory && (
          <ViewHistoryComponent
            setShowViewHistory={setShowViewHistory}
            tableName="UNIT_CONVERSION"
            keyValue={keyValue}
            isSpinner
          />
        )}
      </div>
    </div>
  );
};
export default withRouter(UnitConversionDetail);
